import { Routes, Route, Navigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import ROUTES from "constants/NewRoutes";
import {
  Cast,
  SignIn,
  Users,
  UsersInformation,
  NewActor,
  Categories,
  ContactUs,
  ContactUsRespond,
  Logout,
  Dashboard,
  Genres,
  Subscriptions,
  Banner,
  Home,
  TVShows,
  Questions,
  AddNewQuestion,
  Languages,
  Admins,
  AddEditAdmin,
  EditActor,
  Code,
  Answers,
  AddNewM3U8Movie,
  EditMovieHeaderM3u8,
  AddNewHeaderM3u8,
  EditHeaderM3u8,
  ViewMovieM3u8,
  ViewTvShowsM3u8,
  CodeDetails,
  Notifications,
  // NewHeader,
  TVMedia,
} from "../";

function RoutesFile() {
  const { authorization } = useSelector((state) => state?.auth);
  const isAuthorized = authorization?.token;
  return (
    <Routes>
      <Route
        path={ROUTES.SIGNIN}
        element={
          isAuthorized ? <Navigate to={ROUTES.DASHBOARD} replace /> : <SignIn />
        }
      />
      <Route
        exact
        path={ROUTES.HOME}
        element={
          isAuthorized ? <Home /> : <Navigate to={ROUTES.SIGNIN} replace />
        }
      />
      <Route
        path={ROUTES.DASHBOARD}
        element={
          isAuthorized ? <Dashboard /> : <Navigate to={ROUTES.SIGNIN} replace />
        }
      />
      <Route
        path={ROUTES.ADMINS}
        element={
          isAuthorized ? <Admins /> : <Navigate to={ROUTES.SIGNIN} replace />
        }
      />
      <Route
        path={ROUTES.ADDEDITADMIN}
        element={
          isAuthorized ? (
            <AddEditAdmin />
          ) : (
            <Navigate to={ROUTES.SIGNIN} replace />
          )
        }
      />
      <Route
        path={ROUTES.CAST}
        element={
          isAuthorized ? <Cast /> : <Navigate to={ROUTES.SIGNIN} replace />
        }
      />
      <Route
        path={ROUTES.NEWACTOR}
        element={
          isAuthorized ? <NewActor /> : <Navigate to={ROUTES.SIGNIN} replace />
        }
      />
      <Route
        path={ROUTES.EDITACTOR}
        element={
          isAuthorized ? <EditActor /> : <Navigate to={ROUTES.SIGNIN} replace />
        }
      />
      <Route
        path={ROUTES.CATEGORIES}
        element={
          isAuthorized ? (
            <Categories />
          ) : (
            <Navigate to={ROUTES.SIGNIN} replace />
          )
        }
      />
      <Route
        path={ROUTES.CODE}
        element={
          isAuthorized ? <Code /> : <Navigate to={ROUTES.SIGNIN} replace />
        }
      />
      <Route
        path={ROUTES.CODE_DETAILS}
        element={
          isAuthorized ? (
            <CodeDetails />
          ) : (
            <Navigate to={ROUTES.SIGNIN} replace />
          )
        }
      />
      <Route
        path={ROUTES.LANGUAGES}
        element={
          isAuthorized ? <Languages /> : <Navigate to={ROUTES.SIGNIN} replace />
        }
      />
      <Route
        path={ROUTES.TVSHOWS}
        element={
          isAuthorized ? <TVShows /> : <Navigate to={ROUTES.SIGNIN} replace />
        }
      />
      <Route
        path={ROUTES.ADDNEWHEADER}
        element={
          isAuthorized ? (
            // <NewHeader />
            <AddNewHeaderM3u8 />
          ) : (
            <Navigate to={ROUTES.SIGNIN} replace />
          )
        }
      />
      <Route
        path={ROUTES.EDITTVSHOW}
        element={
          isAuthorized ? (
            // <NewHeader />
            <EditHeaderM3u8 />
          ) : (
            <Navigate to={ROUTES.SIGNIN} replace />
          )
        }
      />

      <Route
        path={ROUTES.VIEWTVSHOWS}
        element={
          isAuthorized ? (
            <ViewTvShowsM3u8 />
          ) : (
            <Navigate to={ROUTES.SIGNIN} replace />
          )
        }
      />
      <Route
        path={ROUTES.MOVIES}
        element={
          isAuthorized ? <TVShows /> : <Navigate to={ROUTES.SIGNIN} replace />
        }
      />
      <Route
        path={ROUTES.ADDNEWMOVIE}
        element={
          isAuthorized ? (
            // <NewHeader />
            <AddNewM3U8Movie />
          ) : (
            <Navigate to={ROUTES.SIGNIN} replace />
          )
        }
      />
      <Route
        path={ROUTES.EDITMOVIEHEADER}
        element={
          isAuthorized ? (
            // <NewHeader />
            <EditMovieHeaderM3u8 />
          ) : (
            <Navigate to={ROUTES.SIGNIN} replace />
          )
        }
      />
      <Route
        path={ROUTES.VIEWMOVIE}
        element={
          isAuthorized ? (
            <ViewMovieM3u8 />
          ) : (
            <Navigate to={ROUTES.SIGNIN} replace />
          )
        }
      />
      <Route
        path={ROUTES.ANIME}
        element={
          isAuthorized ? <TVShows /> : <Navigate to={ROUTES.SIGNIN} replace />
        }
      />
      <Route
        path={ROUTES.TVPROGRAMS}
        element={
          isAuthorized ? <TVShows /> : <Navigate to={ROUTES.SIGNIN} replace />
        }
      />
      <Route
        path={ROUTES.FUNSTORE}
        element={
          isAuthorized ? <TVShows /> : <Navigate to={ROUTES.SIGNIN} replace />
        }
      />
      <Route
        path={ROUTES.GENRES}
        element={
          isAuthorized ? <Genres /> : <Navigate to={ROUTES.SIGNIN} replace />
        }
      />
      <Route
        path={ROUTES.CONTACTUS}
        element={
          isAuthorized ? <ContactUs /> : <Navigate to={ROUTES.SIGNIN} replace />
        }
      />
      <Route
        path={ROUTES.CONTACTUSRESPOND}
        element={
          isAuthorized ? (
            <ContactUsRespond />
          ) : (
            <Navigate to={ROUTES.SIGNIN} replace />
          )
        }
      />
      <Route
        path={ROUTES.USERS}
        element={
          isAuthorized ? <Users /> : <Navigate to={ROUTES.SIGNIN} replace />
        }
      />
      <Route
        path={ROUTES.QUESTIONS}
        element={isAuthorized ? <Questions /> : <Navigate to={ROUTES.SIGNIN} />}
      />
      <Route
        path={ROUTES.ANSWERS}
        element={isAuthorized ? <Answers /> : <Navigate to={ROUTES.SIGNIN} />}
      />
      <Route
        path={ROUTES.ADDNEWQUESTION}
        element={
          isAuthorized ? <AddNewQuestion /> : <Navigate to={ROUTES.SIGNIN} />
        }
      />
      <Route
        path={ROUTES.SUBSCRIPTIONS}
        element={
          isAuthorized ? (
            <Subscriptions />
          ) : (
            <Navigate to={ROUTES.SIGNIN} replace />
          )
        }
      />
      <Route
        path={ROUTES.BANNER}
        element={
          isAuthorized ? <Banner /> : <Navigate to={ROUTES.SIGNIN} replace />
        }
      />
      <Route
        path={ROUTES.USERSINFORMATION}
        element={
          isAuthorized ? (
            <UsersInformation />
          ) : (
            <Navigate to={ROUTES.SIGNIN} replace />
          )
        }
      />

      <Route
        path={ROUTES.NOTIFICATIONS}
        element={
          isAuthorized ? (
            <Notifications />
          ) : (
            <Navigate to={ROUTES.SIGNIN} replace />
          )
        }
      />

      <Route
        path={ROUTES.TV_MEDIA}
        element={
          isAuthorized ? <TVMedia /> : <Navigate to={ROUTES.SIGNIN} replace />
        }
      />

      <Route path={ROUTES.LOGOUT} element={<Logout />} />

      <Route
        path={ROUTES.NOT_FOUND}
        element={
          <>
            <h3 className="d-flex flex-column align-items-center justify-content-center mt-5">
              <div>404</div>
              <div>Page not found</div>
            </h3>
            <h6 className="text-center">
              <Link to={ROUTES.DASHBOARD}>Go to Dashboard</Link>
            </h6>
          </>
        }
      />
    </Routes>
  );
}

export default RoutesFile;
